import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.PICK_UP_PREFERENCE_LIST_SUCCESS, data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.PICK_UP_PREFERENCE_LIST_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const pickUpPreferenceList = (type) => {
  return async (dispatch) => {
    dispatch({ type: CONST.PICK_UP_PREFERENCE_LIST_REQUEST });

    axios.get('/pickup-preferences', { params: { type } }).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
